// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"670efab6","839":"18f19754"}[chunkId] + ".chunk.js";
};